export const REACT_APP_NAV_ROUTES = {
  dashboard: "/dashboard",
  upsellDashboard: "/upsell-dashboard",
  leads: {
    EventLeads: "/leads",
    upsellLeads: "/upsell-leads",
    chatLeads: "/chat-leads",
  },
  chat: "/chats",
  payment: {
    dashboard: "/payment/dashboard",
    paymentDetails: "/payment/payment-details",
  },
  booking: "/bookings",
  customer: "/view-customers",
  inventory: "/inventory",
  food: {
    FoodItems: "/food-items",
    FoodCategories: "/food-categories",
    MasterFoodMenu: "/master-food-menu",
  },
  service: {
    ServiceCategories: "/service-categories",
    Packages: "/packages",
    Items: "/items",
  },
  review: {
    Review: "/review",
    ManageReview: "/manage-review",
  },
  WhatsAppCampaigns: {
    Campaigns: "/market-campaign",
    NewCampaign: "/market-campaign/manage",
    ManageAudience: "/market-campaign-audience",
    MetaTemplate: "/meta-templates",
    QuickReplyTemplate: "/quick-reply-templates",
  },
  Users: "/enr-users",
  Subscription: "/subscription",
  CompanyOutlet: "/company-outlet",
  Zones: "/zone-list",
  CompanyInformation: "/company-information",
  ManageEnv: "/manage-env",
  Automation: "/automation",
  MasterStatus: "/enr-status",
  MasterForms: "/master-forms",
  ENRCancelationReason: "/enr-cancelation-reason",
  ENRSUPPORT: "/enr-support",
  SubscriptionBilling: "/subscription-billing",
  OrganizationSettings: {
    ManageEvents: "/events",
    ManageVenue: "/venue",
    Users: "/users",
    EmailTemplates: "/email-templates",
    DynamicForms: "/dynamic-forms",
    UserBranch: "/user-branch",
    DeletedLeads: "/deleted-leads",
    WhatsAppQR: "/whatsapp-qr",
    OrgConfiguration: "/org-env-config",
    StatusLifeCycle: "/org-status",
    CustomCancellationReason: "/custom-cancellation-reason",
    RestrictedWords: "/restricted-words",
  },
  Security: {
    Security: "/list-security-groups",
    RoleGroups: "/security/role-groups",
  },
  GenAI: {
    GenAIPrompt: "/gen-ai-prompt",
    GenAIContext: "/gen-ai-context",
  },
  MyProfile: "/my-profile",
};
